(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umas-offer-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('umas-offer-bar')) {
  customElements.define('umas-offer-bar', class extends HTMLElement {
    connectedCallback() {
      this.start = Date.parse(this.dataset.start);
      this.duration = Number(this.dataset.hours) * 3600000;
      if (!Number.isFinite(this.start) || !Number.isFinite(this.duration) || this.duration <= 0) return;
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-unit="' + unit + '"]'));
      this.update();
      this.querySelector('.umas-offer-bar__countdown').hidden = false;
      clearInterval(this.interval);
      this.interval = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    update() {
      const elapsed = Math.max(0, Date.now() - this.start);
      const remaining = Math.ceil((this.duration - elapsed % this.duration) / 1000);
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      this.units.forEach((unit, i) => { unit.textContent = String(values[i]).padStart(2, '0'); });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["umas-worn-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('umas-worn'))customElements.define('umas-worn',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.track=this.querySelector('.umas-worn__track');this.buttons=this.querySelectorAll('[data-direction]');this.progress=this.querySelector('.umas-worn__progress span');
this.update=()=>{const max=this.track.scrollWidth-this.track.clientWidth;const fraction=max>0?this.track.scrollLeft/max:0;this.buttons[0].disabled=fraction<=.001;this.buttons[1].disabled=fraction>=.999||max<=0;const width=Math.min(100,this.track.clientWidth/this.track.scrollWidth*100);this.progress.style.width=width+'%';this.progress.style.transform='translateX('+(fraction*(100-width)/width*100)+'%)';};
this.buttons.forEach(b=>b.addEventListener('click',()=>this.track.scrollBy({left:Number(b.dataset.direction)*(this.track.querySelector('figure').offsetWidth+18),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
this.track.addEventListener('scroll',this.update,{passive:true});this.resize=new ResizeObserver(this.update);this.resize.observe(this.track);
this.track.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.target.closest('video'))return;this.drag={x:e.clientX,left:this.track.scrollLeft,id:e.pointerId};this.track.setPointerCapture(e.pointerId);});
this.track.addEventListener('pointermove',e=>{if(!this.drag)return;if(Math.abs(e.clientX-this.drag.x)>5)this.track.classList.add('is-dragging');this.track.scrollLeft=this.drag.left-(e.clientX-this.drag.x);});
const stop=()=>{this.drag=null;this.track.classList.remove('is-dragging');};this.track.addEventListener('pointerup',stop);this.track.addEventListener('pointercancel',stop);
this.addEventListener('play',e=>{this.querySelectorAll('video').forEach(v=>{if(v!==e.target)v.pause();});},true);this.update();
}
disconnectedCallback(){this.resize?.disconnect();this.querySelectorAll('video').forEach(v=>v.pause());}
});

  } catch(e) { console.error(e); }
})();
})();
